import React from 'react';
import { Form, Select } from 'antd';
import { useGetCountries } from 'api/countries/use-get-countries';

interface ICargoFiltersCountryInputProps {
  name: string;
  disabled?: boolean;
  className?: string;
  handleSuccess: () => void;
}

export const CargoFiltersCountryInput: React.FC<ICargoFiltersCountryInputProps> = (props) => {
  const { name, disabled = false, className, handleSuccess } = props;
  const { data: countries } = useGetCountries();

  return (
    <Form.Item name={name} className={className}>
      <Select
        placeholder='Countries'
        mode='multiple'
        disabled={disabled}
        optionFilterProp='label'
        options={countries?.map((country) => ({
          value: country.id,
          label: country.name,
        }))}
        allowClear
        onChange={handleSuccess}
      />
    </Form.Item>
  );
};
